import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../packageCanvas/assets/close-circle.svg'
import _imports_1 from '../../packageCanvas/assets/ask_question.svg'


const _withScopeId = n => (_pushScopeId("data-v-d8a4bfa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading-div" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading-text" }, "Request a key to MiROS", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "icon-button" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"body-div\" data-v-d8a4bfa0> If you have purchased any products including a free version of MiROS, input your details below, and our team will match them with an existing order and provide you with a MiROS key. <div class=\"input-div\" data-v-d8a4bfa0> Email: <input class=\"input-box\" data-v-d8a4bfa0></div><div class=\"input-div\" data-v-d8a4bfa0> Phone number: <input class=\"input-box\" data-v-d8a4bfa0></div><button class=\"rectangle-button\" data-v-d8a4bfa0>Request</button></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "icon-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/payments')))
      }, _hoisted_3),
      _hoisted_4,
      _hoisted_5
    ]),
    _hoisted_6
  ], 64))
}